<div class="login-page">
  <div class="login-form">
    <div class="form-container">
      <h2>Login</h2>

      <!-- Template-driven login form -->
      <form (ngSubmit)="getlogin()">
        <!-- Email -->
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            name="UserName"
            type="email"
            [(ngModel)]="add.UserName"
            placeholder="you@example.com"
            required
          />
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="password">Password</label>
          <div class="password-wrapper">
            <input
              id="password"
              name="Password"
              [type]="hidePassword ? 'password' : 'text'"
              [(ngModel)]="add.Password"
              required
              minlength="6"
            />
            <button
              type="button"
              class="toggle-password"
              (click)="hidePassword = !hidePassword"
            >
              {{ hidePassword ? 'Show' : 'Hide' }}
            </button>
          </div>
        </div>

        <!-- Submit -->
        <button type="submit" class="submit-btn" [disabled]="btndisable" >Login<span *ngIf="btndisable==true" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span></button>
      </form>
    </div>
  </div>
</div>
